import { FC, useEffect, useState } from 'react';
import ReactTimeago, { ReactTimeagoProps } from 'react-timeago';

export const TimeAgo: FC<ReactTimeagoProps> = (props) => {
  const [key, setKey] = useState(0);

  useEffect(() => {
    const bump = () => {
      if (document.visibilityState === 'visible') setKey(k => k + 1);
    };
    document.addEventListener('visibilitychange', bump);
    window.addEventListener('focus', bump);
    return () => {
      document.removeEventListener('visibilitychange', bump);
      window.removeEventListener('focus', bump);
    };
  }, []);

  return <ReactTimeago key={key} {...props} />;
};